var pug = require("!../../../../pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (icons, item, texts, type) {let prependIcon = {
    'accordionTrigger' : true,
    'accordionLink' : true,
    'link' : true,
};
let iconSelector = {
    'accordionTrigger' : icons['ICON_PLUS'],
    'accordionLink' : icons['ICON_RETURN'],
    'link' : icons['ICON_RETURN'],
};
let classes = {
    'accordionTrigger': '',
    'accordionLink': '',
    'link': '',
};

pug_mixins["menuBtnContent"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const selector = 'accordionTrigger';
const icon = iconSelector[selector];
if ((prependIcon[selector] && icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003Cspan" + (" class=\"accordion__toggle__title\""+pug.attr("data-expand-title", texts[type + 'Hide'], true, true)+pug.attr("data-collapsed-title", texts[type + 'Show'], true, true)) + "\u003E\u003C\u002Fspan\u003E";
if ((!prependIcon[selector] && icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
};
pug_mixins["xrefLinkContent"] = pug_interp = function(point, text){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const selector = !!text ? 'link' : 'accordionLink';
const icon = iconSelector[selector];
if ((prependIcon[selector] && icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = text || point.content) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
if ((!prependIcon[selector] && icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
};
pug_mixins["xrefLink"] = pug_interp = function(point, text, role){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const extraClass = !!text ? classes['link'] : classes['accordionLink']
if ((point.openInViewer)) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes(["to-citation",extraClass], [false,true]), false, true)+pug.attr("data-target", point.href, true, true)+pug.attr("data-index", point.index, true, true)+" data-open=\"viewer\""+pug.attr("role", role, true, true)) + "\u003E";
pug_mixins["xrefLinkContent"](point, text);
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes(["to-citation",extraClass], [false,true]), false, true)+pug.attr("href", point.href, true, true)+" target=\"_self\""+pug.attr("role", role, true, true)) + "\u003E";
pug_mixins["xrefLinkContent"](point, text);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
};
if ((item.points.length > 0)) {
pug_html = pug_html + "\u003Cdiv class=\"to-citation__wrapper\"\u003E";
if ((item.points.length === 1)) {
pug_mixins["xrefLink"](item.points[0], texts[type+'Goto']);
}
else
if ((item.points.length > 1)) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes(["to-citation__toggle",classes['accordionTrigger']], [false,true]), false, true)+pug.attr("aria-controls", 'to-citation__accordion-'+item.id, true, true)+" data-trigger=\"dropdown\""+pug.attr("aria-label", texts[type+'Toggle'], true, true)) + "\u003E";
pug_mixins["menuBtnContent"]();
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003Cdiv" + (" class=\"to-citation__accordion no-separator\""+pug.attr("id", 'to-citation__accordion-'+item.id, true, true)+" role=\"menu\""+pug.attr("aria-label", texts[type+'Links'], true, true)) + "\u003E\u003Cul role=\"none\"\u003E";
// iterate item.points
;(function(){
  var $$obj = item.points;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var point = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli role=\"none\"\u003E";
pug_mixins["xrefLink"](point, undefined, 'menuitem');
pug_html = pug_html + "\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var point = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli role=\"none\"\u003E";
pug_mixins["xrefLink"](point, undefined, 'menuitem');
pug_html = pug_html + "\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}}.call(this,"icons" in locals_for_with?locals_for_with.icons:typeof icons!=="undefined"?icons:undefined,"item" in locals_for_with?locals_for_with.item:typeof item!=="undefined"?item:undefined,"texts" in locals_for_with?locals_for_with.texts:typeof texts!=="undefined"?texts:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined));;return pug_html;};
module.exports = template;